<template>
  <div class="wpCancelReservations">
    
    <el-dialog title="添加限制对象" :visible.sync="dialogTableVisible" width="520px" append-to-body
      @close="clearAddInformation()">
      <el-form ref="form" :model="form" label-width="80px">
        <table class="wpCancelReservations" style="width: 100%">
          
          <tr>
            <td class="td_left"> 申请人：</td>
            <td class="td_right">{{ addInformation.RealName }}</td>
          </tr>

          <!-- <tr>
            <td class="td_left">限制类型:</td>

            <td class="td_right">
              <el-radio-group v-model="addInformation.ctm">
                <el-radio label="1">个人</el-radio>
                <el-radio label="0">团体</el-radio>
              </el-radio-group>
            </td>

          </tr> -->

          <tr>
            <td class="td_left">限制对象:</td>
            <td class="td_right">
              <el-select style="width: 100%;" filterable remote reserve-keyword :placeholder="$t('original.languages250')"
                :remote-method="getVsitorNameList" v-model="addInformation.UserID" :change="selectVsitorName()">
                <el-option v-for="item in VsitorNameList" :key="item.UserID" :label="item.RealName" :value="item.UserID"
                  :disabled="!item.Disabled"></el-option>
              </el-select>
            </td>
          </tr>

          <!-- <tr v-if="addInformation.ctm == '0'">
            <td class="td_left">限制对象:</td>
            <td class="td_right">
              <el-cascader ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" :options="options" :props="{ checkStrictly: true }" clearable></el-cascader>
            </td>
          </tr> -->

          <tr v-if="addInformationShow">
            <td class="td_left">部门名称</td>
            <td class="td_right">
              {{ addInformation.DeptName }}
            </td>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left">限制时间</td>
            <td class="td_right">
              <el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
              </el-date-picker>
            </td>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left"> {{ $t('original.languages213') }}</td>
            <td class="td_right">
              <el-input type="textarea" v-model="addInformation.ConsultingBlacklistCause" resize="none"></el-input>
            </td>
          </tr>

          <tr>
            <td colspan="2">
              <div class="buttons" style="width: 100%">
                <el-button @click="dialogTableVisible = false"> {{ $t('original.cancel') }}</el-button>
                <el-button type="primary" @click="AddConsultingBlacklist()" :loading="ConsultingBlackload">
                  {{ $t('original.languages59') }}
                </el-button>
              </div>
            </td>
          </tr>
        </table>
      </el-form>
    </el-dialog>

    <el-dialog :title="$t('original.languages50')" :visible.sync="dialoginfoVisible" width="520px" append-to-body @close="clearAddInformation()">
      <el-form ref="form" label-width="80px">
        <table class="wpCancelReservations" style="width: 100%;border-radius: 4px;">
          <tr>
            <td class="td_left" style="padding: 10px ; width: 25%">{{ $t('original.languages185') }} ：</td>
            <td class="td_right">{{ AppointmentInfo.CounselorID }}</td>
          </tr>
          <tr>
            <td class="td_left" style="padding: 10px  ; width: 25%">
             {{ $t('original.languages249') }} ：
            </td>
            <td class="td_right">
              {{
                  AppointmentInfo.RealName + '(' + AppointmentInfo.UserID + ') '
              }}
            </td>
          </tr>

          <tr>
            <td class="td_left" style="padding: 10px ; width: 25%">
             {{ $t('original.languages251') }} ：
            </td>
            <td class="td_lefttd_right">
              {{ AppointmentInfo.ConsultingBlacklistCause }}
            </td>
          </tr>

          <tr>
            <td class="td_left" style="padding: 10px ; width: 25%">
              限制时间 ：
            </td>
            <td class="td_lefttd_right">
              {{ AppointmentInfo.time }}
            </td>
          </tr>
          
        </table>

        <table class="wpCancelReservations" style="width: 100%">
          <tr>
            <td class="td_left" style="padding: 10px; width: 25%">{{ $t('original.languages190') }}</td>
            <td class="td_right" :style="AppointmentInfo.ConsultingBlacklistState == 1 ? 'color: rgba(29, 154, 255, 1);' : AppointmentInfo.ConsultingBlacklistState == 2 ? 'color: rgba(21, 191, 109, 1);' : AppointmentInfo.ConsultingBlacklistState == 4 ? 'color: rgba(141, 141, 141, 1);' : 'color: rgba(242, 75, 78, 1);'">
              {{
                  AppointmentInfo.ConsultingBlacklistState == 1
                    ?  $t('original.languages252')
                    : AppointmentInfo.ConsultingBlacklistState == 2
                    ? $t('original.languages203')
                    : AppointmentInfo.ConsultingBlacklistState == 4
                    ? $t('original.languages205')
                    : $t('original.languages204')
              }}
            </td>
          </tr>
          <tr v-if="AppointmentInfo.ConsultingBlacklistState == 2">
            <td class="td_left" style="padding: 10px"> {{ $t('original.note') }}</td>
            <td class="td_right">
              {{ AppointmentInfo.ConsultingBlacklistNotes }}
            </td>
          </tr>
          <tr v-if="AppointmentInfo.ConsultingBlacklistState == 3">
            <td class="td_left" style="padding: 10px"> {{ $t('original.languages191') }}</td>
            <td class="td_right">
              {{ AppointmentInfo.ConsultingBlacklistNotes }}
            </td>
          </tr>

          <tr v-if="AppointmentInfo.ConsultingBlacklistState != 1 && AppointmentInfo.ConsultingBlacklistState != 4">
            <td class="td_left" style="padding: 10px"> {{ $t('original.languages192') }}</td>
            <td class="td_right">
              {{ AppointmentInfo.ApproverID }}
            </td>
          </tr>
          <tr v-if="AppointmentInfo.ConsultingBlacklistState != 1 && AppointmentInfo.ConsultingBlacklistState != 4">
            <td class="td_left" style="padding: 10px">{{ $t('original.languages193') }}</td>
            <td class="td_right">
              {{ AppointmentInfo.ApproverTime }}
            </td>
          </tr>
          <tr v-if="AppointmentInfo.ConsultingBlacklistState == 1">
            <td colspan="2">
              <div class="buttons" style="width: 100%; text-align: right">
                <el-button @click="dialoginfoVisible = false">{{ $t('original.cancel') }}</el-button>
                <el-button style="margin-right: 20px" type="primary" @click="evocation(AppointmentInfo.ConsultingBlacklistID)">
                 {{ $t('original.languages253') }}
                </el-button>
              </div>
            </td>
          </tr>
        </table>
      </el-form>
    </el-dialog>

    <el-container>
      <el-header style="background: rgba(255, 255, 255, 1);max-height: 206px;min-height: 100px;height: auto;">
        <el-form ref="form" :model="form" label-width="80px" style="margin: 20px 0px;background: rgba(255, 255, 255, 1);padding: 10px;overflow: hidden;height: 42px;">
          <el-row style="float: left; height: 42px;">

            <el-col :xl="6" :lg="6" :md="6" :sm="6" :xs="24">
              <div class="grid-content">
                <el-form-item :label="$t('original.account')">
                  <el-input v-model="form.UserID" :placeholder="$t('original.languages254')"></el-input>
                </el-form-item>
              </div>
            </el-col>

            <el-col :xl="6" :lg="6" :md="6" :sm="6" :xs="24">
              <div class="grid-content">
                <el-form-item :label="$t('original.Name_of_Company')" prop="bumen">
                  <div class="block">
                    <!-- <el-cascader ref="wcascader" emitPath:false :show-all-levels="false" v-model="form.DepartID"
                      :options="DepartDrop" :props="{ checkStrictly: true, emitPath: false }" clearable></el-cascader> -->
                      <el-cascader ref="wcascaderssss" @change="Selected_to_shut_dow2" @expand-change="bumen" :options="DepartDrop" :props="{ checkStrictly: true }" clearable></el-cascader>
                  </div>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="6" :lg="6" :md="6" :sm="6" :xs="24">
              <div class="grid-content">
                <el-form-item :label="$t('original.languages190')">
                  <el-select v-model="form.CancelApproval" :placeholder="$t('original.languages3')">
                    <el-option :label="$t('original.languages114')" value="0"></el-option>
                    <el-option :label="$t('original.languages227')" value="1"></el-option>
                    <el-option :label="$t('original.languages203')" value="2"></el-option>
                    <el-option :label="$t('original.languages204')" value="3"></el-option>
                    <el-option label="已撤销" value="4"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row style="float: right; height: 42px;">
            <el-col :xl="24" style="text-align: right">

              <el-button type="primary" @click="aaax()">筛选</el-button>
              <el-button type="primary" @click="clearFrom();">
                  重置
              </el-button>
            </el-col>
          </el-row>

        </el-form>
      </el-header>
      <el-main style="margin-top: 15px; background: rgba(255, 255, 255, 1)" class="el-Content">
        <el-row>
          <el-col :xl="24" style="margin-bottom: 20px">
            <el-button type="primary" :loading="loadingstart" @click="dialogTableVisible = true">{{ $t('original.languages255') }}</el-button>
            <!-- <el-button type="primary" :loading="loadingstart" @click="dialo()">
              访谈排版
            </el-button> -->
          </el-col>
          <el-table ref="multipleTable" v-loading="load" :element-loading-text="$t('original.languages22')"
            element-loading-spinner="el-icon-loading" :data="tableData" tooltip-effect="dark" style="width: 100%">
            
            <el-table-column :label="$t('original.The_serial_number')" min-width="5%">
              <template slot-scope="scope">
               {{ (form.pageIndex - 1) * 10 + scope.$index + 1 }}
              </template>
            </el-table-column>
            
            <el-table-column prop="UserID" :label="$t('original.account')" min-width="8%"></el-table-column>
            <el-table-column prop="RealName" :label="$t('original.name')" min-width="8%"></el-table-column>
            <el-table-column prop="Sex" :label="$t('original.gender')" min-width="5%"></el-table-column>
            <el-table-column prop="Age" :label="$t('original.languages256')" min-width="5%"></el-table-column>
            <el-table-column prop="DeptName" :label="$t('original.Name_of_Company')" min-width="20%"></el-table-column>
            <el-table-column min-width="12%" prop="CreatorTime" :label="$t('original.languages217')"></el-table-column>
            <el-table-column prop="ConsultingBlacklistState" :label="$t('original.languages190')" min-width="10%">
              <template slot-scope="scope">
                <span :class="scope.row.ConsultingBlacklistState == 1 ? 'Statusblue' : scope.row.ConsultingBlacklistState == 2 ? 'Statusgreen' : scope.row.ConsultingBlacklistState == 4 ? 'Statusgray' : 'Statusred'">
                  {{
                      scope.row.ConsultingBlacklistState == 1 ? $t('original.languages227') : scope.row.ConsultingBlacklistState == 2 ? $t('original.languages203') : scope.row.ConsultingBlacklistState == 4 ? $t('original.languages205') : $t('original.languages204')
                  }}
                </span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages49')" min-width="15%" align="center">
              <template slot-scope="scope">
                <span @click="dialoginfoVisible = true;
                SetAppointmentInfo(scope.row);" class="table_btn">
                   {{ $t('original.languages174') }}
                </span>
                <span v-if="scope.row.ConsultingBlacklistState == 1" class="table_btn"
                  @click="evocation(scope.row.ConsultingBlacklistID)">
                   {{ $t('original.languages253') }}
                </span>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination @current-change="handleCurrentChange" :current-page.sync="form.pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts"></el-pagination>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import moment from 'moment';
import add from '../Measurement/add.vue';
export default {
  components: { add },
  mounted() {

    this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: '', content: '' }).then((res) => {
      if (res.Code == 200 || res.Code == 0 && res.Data) {
        this.options = res.Data;
        this.DepartDrop = res.Data;
      }
    })

    this.getConsultingBlacklist(this.form);
  },
  data() {
    return {

      Counts:0,
      DeptID: '',
      value1:'',
      load: false,
      dialogTableVisible: false, // 添加取消预约弹框
      addInformationShow: false, //控制添加申请附加信息显示
      dialoginfoVisible: false,
      loadingstart: false,
      VsitorNameList: [],
      tableData: [], //列表表格数据
      DepartDrop: [],
      form: {
        entity: sessionStorage.getItem('entity'),
        CancelApproval: '',
        UserID: '',
        DepartID: '',
        pageSize: '10',
        pageIndex: 1,
      },
      addInformation: {
        RealName: JSON.parse(localStorage.getItem('userInfo')).UserName,
        UserID: '', //来访者姓名
        DeptName: '',
        ConsultingBlacklistCause: '',
        ctm:'1'
        // RealName: localStorage.getItem(JSON.parse(userInfo).UserName),
      },
      AppointmentInfo: {
        CounselorID: '',
        RealName: '',
        UserID: '',
        RelieveRecordNum: '',
        Assessment: '',
        RelieveRecordCause: '',
        ConsultingBlacklistState: '',
        RelieveRecordNotes: '',
        ApproverID: '',
        time: '',
      },
      ConsultingBlackload:false
    };
  },
  methods: {
    aaax() {
      this.form.pageIndex = 1;
      this.getConsultingBlacklist(this.form);
    },
    handleCurrentChange(val) {
      this.form.pageIndex = val;
      this.getConsultingBlacklist(this.form);
    },
    Selected_to_shut_dow(dt) {
      this.DeptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    Selected_to_shut_dow2(dt) {
      this.form.DepartID = dt[dt.length - 1];
      this.$refs.wcascaderssss.dropDownVisible = false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i]
          break
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children)
          if (obj != null) break
        }
      }
      return obj
    },
    bumen(dt) {
      let obj = this.options[0];
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].DeptID == dt[dt.length - 1]) {
          obj = this.options[i]
          break
        } else if (this.options[i].fuzi && this.options[i].children.length > 0 && this.options[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(
            dt[dt.length - 1],
            this.options[i].children,
          )
        }
      }
      let _this = this
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: this.$t('original.languages22') }];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: dt[dt.length - 1], content: '' }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data
          }
        })
      }
    },
    dialo() {
      this.$router.push('/Interview/Conference_room');
    },
    getVsitorNameList(query) {
      if (query !== '') {
        this.loadingstart = true;
        this.$Http_Post('ConsultSubscribe/GetBlacklistNameList', {
          Query: query,
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.loadingstart = false;
            this.VsitorNameList = res.Data;
          }
        });
      } else {
        this.VsitorNameList = [];
      }
    },
    selectVsitorName() {
      for (let index = 0; index < this.VsitorNameList.length; index++) {
        if (this.VsitorNameList[index].UserID == this.addInformation.UserID) {
          this.addInformationShow = true;
          this.addInformation.DeptName = this.VsitorNameList[index].DeptName;
        }
      }
    },
    clearAddInformation() {
      this.addInformationShow = false;
      this.addInformation.AppointmentTime = '';
      this.addInformation.ConAddressName = '';
      this.addInformation.ConsultType = '';
      this.addInformation.CancelCause = '';
      this.addInformation.ConsultCntIntroduce = '';
      this.addInformation.ConsultTheme = '';
      this.addInformation.UserID = '';
      this.addInformation.DeptName = '';
    },

    AddConsultingBlacklist() {

      // if (
      //   this.addInformation.UserID == '' ||
      //   this.addInformation.UserID == null
      // ) {
      //   this.$message({
      //     message: this.$t('original.languages49'),
      //     type: 'success',
      //   });
      //   return;
      // }

      this.ConsultingBlackload=true;
      //申请解禁
      this.$Http_Post('ConsultSubscribe/AddConsultingBlacklist', {
        UserID: this.addInformation.UserID, //来访者
        ConsultingBlacklistCause: this.addInformation.ConsultingBlacklistCause,
        StartTime: this.value1[0],
        EndTime: this.value1[1],
        DeptID:this.DeptID
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$message({
            message: this.$t('original.languages258'),
            type: 'success',
          });
          this.getConsultingBlacklist(this.form);
          this.dialogTableVisible = false;
        }else{
          this.$message({
            message:res.Message,
            type: 'error',
          });
        }
        this.ConsultingBlackload=false;
      });
    },

    getConsultingBlacklist(from) {
      this.load = true;
      this.$Http_Post('ConsultSubscribe/GetConsultingBlacklist', {
        form: from,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data.Lists;
          this.Counts = res.Data.Count

          this.load = false;
        }
      });
    },
    clearFrom() {
      this.form.CancelApproval = '';
      this.form.UserID = '';
      this.form.DepartID = '';
      this.form.pageIndex = 1;
      this.getConsultingBlacklist(this.form);
    },
    SetAppointmentInfo(row) {
      this.AppointmentInfo.CounselorID = row.CounselorID;
      this.AppointmentInfo.RealName = row.RealName;
      this.AppointmentInfo.UserID = row.UserID;
      this.AppointmentInfo.ConsultingBlacklistCause = row.ConsultingBlacklistCause;
      this.AppointmentInfo.ConsultingBlacklistState = row.ConsultingBlacklistState;
      this.AppointmentInfo.ConsultingBlacklistNotes = row.ConsultingBlacklistNotes;
      this.AppointmentInfo.ApproverID = row.ApproverID;
      this.AppointmentInfo.ConsultingBlacklistID = row.ConsultingBlacklistID;
      this.AppointmentInfo.time = row.StartTime +   '  至  '    + row.EndTime
      this.AppointmentInfo.ApproverTime = moment
      
        .utc(row.ApproverTime)
        .local()
        .format('yyyy-MM-DD HH:mm:ss');
    },
    evocation(ConsultingBlacklistID) {
      this.$Http_Post('ConsultSubscribe/UpdateConsultingBlacklist', {
        ConsultingBlacklistID: ConsultingBlacklistID,
        ConsultingBlacklistState: 4,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$message({
            message: this.$t('original.languages259'),
            type: 'success',
          });
          this.dialogTableVisible = false;
          this.dialoginfoVisible = false;
          for (let index = 0; index < this.tableData.length; index++) {
            if (
              ConsultingBlacklistID == this.tableData[index].ConsultingBlacklistID
            ) {
              this.tableData[index].ConsultingBlacklistState = 4;
            }
          }
        }else{
          this.$message({
            message:res.Message,
            type: 'error',
          });
        }
      });
    },
  },
};
</script>

<style>
.el-Content {
  height: 100%;
}

.el-table--enable-row-transition .el-table__body td {
  text-align: center;
}

.wpCancelReservations {
  height: 100%;
}

.wpCancelReservations .td_left {
  color: rgba(141, 141, 141, 1);
  font-size: 14px;
  padding: 15px;
  width: 65px;
}

.wpCancelReservations .td_right {
  text-align: left;
  font-size: 14px;
  color: rgba(40, 40, 40, 1);
}

.el-dialog {
  height: auto !important;
}

.wpCancelReservations .buttons {
  width: 100%;
  text-align: center;
  margin: 20px;
}

.wpCancelReservations .Statusblue {
  border-radius: 4px;
  padding: 5px 10px;
  background: rgba(29, 154, 255, 0.1);
  color: rgba(29, 154, 255, 1);
}

.wpCancelReservations .Statusgreen {
  border-radius: 4px;
  background-color: rgba(21, 191, 109, 0.1);
  color: rgba(21, 191, 109, 1);
  padding: 5px 10px;
}

.wpCancelReservations .Statusred {
  border-radius: 4px;
  background-color: rgba(242, 75, 78, 0.1);
  color: rgba(242, 75, 78, 1);
  padding: 5px 10px;
}

.wpCancelReservations .Statusgray {
  border-radius: 4px;
  padding: 5px 10px;
  background: rgba(141, 141, 141, 0.1);
  color: rgba(141, 141, 141, 1);
}

.wpCancelReservations .el-radio-group{margin-left: 0px;}
</style>
